import type { QueryClient } from 'react-query';

import minutesToMilliseconds from 'date-fns/minutesToMilliseconds';

import { fetchMe } from '@api/user';
import { QUERY_KEYS } from '@constants';
import { IUserMe } from '@model';

export const CURRENT_USER_STALE_TIME = minutesToMilliseconds(60);
export const CURRENT_USER_CACHE_TIME = minutesToMilliseconds(60);

export const currentUserPrefetcher = {
  prefetch(queryClient: QueryClient, accessToken: string) {
    return queryClient.prefetchQuery<IUserMe>(
      QUERY_KEYS.USER.ME,
      () => fetchMe(accessToken),
      {
        staleTime: CURRENT_USER_STALE_TIME,
        cacheTime: CURRENT_USER_CACHE_TIME,
      }
    );
  },
};
